export const USER_ROLES = {
  SUPER_ADMIN: "1",
  HEALTH_PROFESSIONAL: "2",
};
